import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import greaterThanIcon from "../../assets/icons/greaterthan.png";
import leftArrowIcon from "../../../public/assets/images/leftArrowIcon.png";
import ExpenseApprovaldetails from "./ExpenseApprovaldetails";
import { truncateText } from '../../utils/utilFun';
import { expenseApprovaldetails,expenseWisedetails } from '../../redux/slice/expenseApproval';
import { useDispatch, useSelector } from 'react-redux';
import handpoint from '../../assets/icons/handpoint.png';
import { Tooltip } from "react-tooltip";
import Loader from '../../components/modal/Loader.jsx';


const ExpenseApproval = () => {
const navigate = useNavigate();
const dispatch = useDispatch();
const { isLoading, data = [] } = useSelector((state) => state.expenseApproval);

  useEffect(() => {
    dispatch(expenseApprovaldetails());
  }, [dispatch]);


  const handleRowClick = (item) => {
        dispatch(expenseWisedetails(item.expenseId,item.employeeId));
        navigate(`/expense-details/${item.expenseId}`);
};
  const [expandedRow, setExpandedRow] = useState(null);

  const handleDataClick = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  }

  return (
    <div className="w-full flex flex-col bg-white lg:pt-16 lg:p-4 smAndMd:-pt-32 min-h-screen ">
      {isLoading ?( <Loader />):(
  <>
      <div className="flex justify-center items-center w-full h-10 relative p-4 lg:p-2 mt-20 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center smAndMd:mt-6 smAndMd:mb-4 px-3 py-5">
        <Link to="/home" className="absolute left-4 lg:hidden">
          <img src={leftArrowIcon} alt="leftIcon" height={"10px"} width={"10px"} />
        </Link>
        <p className="text-lg font-semibold text-center lg:-ml-2 text-primary lg:text-baselg lg:font-semibold">
          Expense Approval
        </p>
      </div>
      <div className="w-full h-[0.5px] bg-line-color smAndMd:hidden"></div>


      <div className="mt-7">
  {Array.isArray(data) && data.length > 0 ? (
    <>
      {/* Table Header */}
      <div className="grid grid-cols-7 bg-gray-200 flex-wrap rounded-t-md p-4 font-semibold text-xs text-center text-gray-700 smAndMd:hidden">
        <div className="col-span-1">Employee Name</div>
        <div className="col-span-1 border-l border-gray-400">Hierarchy Type</div>
        <div className="col-span-1 border-l border-gray-400">Hierarchy Name</div>
        <div className="col-span-1 border-l border-gray-400">Design/Grade</div>
        <div className="col-span-1 border-l border-gray-400">Month/Year</div>
        <div className="col-span-1 border-l border-gray-400">Submitted Date</div>
        <div className="col-span-1 border-l border-gray-400">Status</div>
      </div>

      {/* Table Body Rows */}
      {data.map((item, index) => (
  <div
    key={index}
    className="bg-white flex-wrap  border border-t-0 border-gray-300 smAndMd:hidden"
  >
    <div
      className="grid grid-cols-7 !items-center text-xs !text-center font-medium text-[#514D4C] p-3 truncate"

    >
      <div className="col-span-1 text-primary flex !items-center gap-3 hover:underline font-semibold cursor-pointer "
      onClick={(e) => {
        e.stopPropagation();
        handleRowClick(item);
      }}
      data-tooltip-id="click"
      data-tooltip-content='Click to view Expense Details'
      >
        <img src={handpoint} className="w-3 h-3" alt="Handpoint" />
        {item.employeeName}
        <Tooltip id='click' className="!text-xs font-normal !z-50"/>
      </div>
      <div className="col-span-1">{item.hirarchyType}</div>
      <div className="col-span-1">{item.hirarchyName}</div>
      <div className="col-span-1">{truncateText(item.desigGrade,20)}</div>
      <div className="col-span-1">{item.monthYear}</div>
      <div className="col-span-1">{item.submittedDate}</div>
      <div className="col-span-1">{item.status}</div>
    </div>

  </div>

))}
    </>
  ) : (
    <div className="text-primary flex justify-center items-center font-medium h-1/2 mt-56 smAndMd:hidden">
      <p className="text-primary font-medium">No Data Found</p>
    </div>
  )}
</div>
</>
)}



        {/* Table Header for Mobile view*/}
        <div className="lg:hidden">
  {Array.isArray(data) && data.length > 0 ? (
    <>
      {/* Table Header */}
      <div className="lg:hidden grid grid-cols-3 bg-gray-200 rounded-t-md -mt-8 p-2 font-semibold text-[12px] text-center text-gray-700">
        <div className="col-span-1 p-2 truncate w-17">Employee Name</div>
        <div className="col-span-1 border-l border-gray-400 p-2 truncate w-17">Hierarchy Type</div>
        <div className="col-span-1 border-l border-gray-400 p-2 truncate w-17">Submitted Date</div>
      </div>

      {/* Table Body */}
      <div className="bg-white flex-wrap rounded-b-md border text-center border-t-0 border-gray-300 lg:hidden">
        {data.map((item, index) => (
          <div key={index}>
            <div
              className="grid grid-cols-3 items-center text-xs text-center cursor-pointer font-medium text-[#514D4C] p-4"

            >
              <div
                className="flex items-center font-medium text-center text-primary underline "
              >
                <img
                  src={greaterThanIcon}
                  className={`w-8 h-8 transform transition-transform ${
                    expandedRow === item.employeeName ? "rotate-90" : ""
                  }`}
                  alt="toggle"
                  onClick={() => handleDataClick(item.employeeName)}
                />
                <span  onClick={(event) => {
                  event.stopPropagation();
                  handleRowClick(item);
                }}>
                {item.employeeName}
                </span>
              </div>
              <div className="col-span-1">{item.hirarchyType}</div>
              <div className="col-span-1">{item.submittedDate}</div>
            </div>

            {index < data.length - 1 && <hr className="border-t border-gray-300" />}

            {/* Expanded Row */}
            {expandedRow === item?.employeeName && (
              <div className="border border-gray-200 rounded-sm pb-2 text-[14px] items-center text-gray-700">
                <p className="font-semibold text-left shadow-sm bg-primary-100 text-black pl-4 p-2">
                  Approval Details
                </p>
                <div className="bg-gray-200 w-full h-[1px]" />

                <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] pt-2 text-gray-600">
                  <p className="font-medium text-left">Hierarchy Name</p>
                  <p className="text-right">{item.hirarchyName}</p>
                </div>
                <div className="grid grid-cols-2 gap-x-6 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-gray-600">
                  <p className="font-medium text-left">Designation/Grade</p>
                  <p className="text-right">{item.desigGrade}</p>
                </div>
                <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-gray-600">
                  <p className="font-medium text-left">Month/Year</p>
                  <p className="text-right">{item.monthYear}</p>
                </div>
                <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-gray-600">
                  <p className="font-medium text-left">Status</p>
                  <p className="text-right">{item.status}</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className="text-primary flex justify-center items-center font-medium h-1/2 mt-56 ">
    <p className="text-primary font-medium">No Data Found</p>
  </div>
  )}
</div>
</div>
  );
};

export default ExpenseApproval;
